import CommonIPAddress from "../Common/IPAddress";
export default class IPAddress {
    /**
     * Returns the IPAddress of the requesting user
     * @param headers Pass useRequestHeaders() as headers
     */
    public static get(headers:  Readonly<Record<string, string>>): string | null {
        return CommonIPAddress.get(headers);
    }
}
